export const templateDrinksBar = {

config:{
cor_primaria:"#000",
tipo_fundo:"solido"
},

elementos:[

{
id:1,
tipo:"texto",
conteudo:"COCKTAIL BAR",
pos_x:70,
pos_y:40,
estilo:{fontSize:32,color:"#00d2ff",fontWeight:"bold"}
},

{
id:2,
tipo:"texto",
conteudo:"DRINKS",
pos_x:140,
pos_y:120,
estilo:{fontSize:20,color:"#fff"}
},

{
id:3,
tipo:"texto",
conteudo:"Mojito",
pos_x:30,
pos_y:180,
estilo:{fontSize:16,color:"#fff"}
},

{
id:4,
tipo:"texto",
conteudo:"R$ 22",
pos_x:260,
pos_y:180,
estilo:{fontSize:16,color:"#00d2ff"}
}

]

};